/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_Working_StyleInputs */

const en_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working from home`)
};

const ar_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعمل من المنزل`)
};

const bn_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাসা থেকে কাজ করছি`)
};

const de_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitet von zu Hause`)
};

const es_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajar desde casa`)
};

const fr_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travailler à domicile`)
};

const pt_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhando em casa`)
};

const zh_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在家工作`)
};

const tr_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evden çalışma`)
};

const ru_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работа на дому`)
};

const pl_typewriter_working_style = /** @type {(inputs: Typewriter_Working_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca w domu`)
};

/**
* | output |
* | --- |
* | "Working from home" |
*
* @param {Typewriter_Working_StyleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_working_style = /** @type {((inputs?: Typewriter_Working_StyleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_Working_StyleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_working_style(inputs)
	if (locale === "bn") return bn_typewriter_working_style(inputs)
	if (locale === "de") return de_typewriter_working_style(inputs)
	if (locale === "es") return es_typewriter_working_style(inputs)
	if (locale === "fr") return fr_typewriter_working_style(inputs)
	if (locale === "pt") return pt_typewriter_working_style(inputs)
	if (locale === "zh") return zh_typewriter_working_style(inputs)
	if (locale === "tr") return tr_typewriter_working_style(inputs)
	if (locale === "ru") return ru_typewriter_working_style(inputs)
	if (locale === "pl") return pl_typewriter_working_style(inputs)
	return en_typewriter_working_style(inputs)
});